
/* injects from baggage-loader */

'use strict';

import AccountProjectsComponent from './account.projects.component';

const AccountProjectsPageModule = angular.module('account-projects-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account.projects', {
        url: '/projects',
        component: 'accountProjects',
        // Requires valid login to view
        protected: true,
        // Resolve promises into controller bindings, see component for bindings
        resolve: { 
          projects: function(Projects, ProjectStatusSchema) {
            return Projects.listMine();
          }
        }
      });
  })
  .component('accountProjects', new AccountProjectsComponent());

export default AccountProjectsPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/projects/account.projects.module.js